export default __webpack_public_path__ + "static/media/seguimiento.5c5231de.png";